import { lazy } from 'react';
import { authRoles } from '@/app/auth';
import { apiRoutes } from '@/app/apiConfig/apiRoutes';

const AddPayor = lazy(() => import('./AddPayor'));

const AddPayorConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.Payments,
  routes: [
    {
      path: apiRoutes.addPayor,
      element: <AddPayor />,
    },
    {
      path: `${apiRoutes.payors}/:id`,
      element: <AddPayor />,
    },
  ],
};

export default AddPayorConfig;
